<template>
  <div>
    <button type="button" class="btn btn-primary" v-show="!recording" v-on:click.stop.prevent="toggleRecording">
      <i class="fas fa-microphone" v-show="!isRecording"></i>
      <i class="fal fa-microphone" v-show="isRecording">&nbsp;Recording...</i>
      <!-- <i class="record icon" v-show="!isRecording"></i> -->
    </button>

    <!-- <audio id="audio" preload="auto" v-bind:src="dataUrl"></audio> -->
    <audio
      v-show="recording"
      id="audio"
      preload="metadata"
      controls="true"
      controlsList="nodownload"
      v-bind:src="recording"
    ></audio>
    <button class="btn btn-danger" v-if="recording" v-on:click.stop.prevent="removeRecording">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>
import { http } from 'utils'

export default {
  props: {
    save: Function,
    delete: Function,
    recording: String,
  },

  data: function () {
    return {
      isRecording: false,
      audioRecorder: null,
      recordingData: [],
      dataUrl: '',
    }
  },
  mounted: function () {},

  methods: {
    toggleRecording: function () {
      var that = this

      if (!this.isRecording) {
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia
        navigator.getUserMedia(
          {
            audio: true,
            video: false,
          },
          function (stream) {
            that.stream = stream
            that.audioRecorder = new MediaRecorder(stream, {
              mimeType: 'audio/webm',
              audioBitsPerSecond: 32000,
            })
            that.audioRecorder.start()

            that.audioRecorder.ondataavailable = function (event) {
              that.recordingData.push(event.data)
            }
            that.audioRecorder.onstop = function (event) {
              var blob = new Blob(that.recordingData, { type: 'audio/webm' })
              console.log(blob.size / 1000 / 1000 + 'MB')
              that.dataUrl = window.URL.createObjectURL(blob)

              that.save(blob)
            }

            that.isRecording = true
          },
          function (error) {
            alert(error)
          }
        )
      } else {
        this.isRecording = false
        this.audioRecorder.stop()
      }
    },
    removeRecording: function () {
      this.isRecording = false
      this.recordingData = []
      this.dataUrl = ''
      this.delete()
    },
    togglePlay: function () {
      var audioElement = document.getElementById('audio')

      if (audioElement.paused === false) {
        audioElement.pause()
      } else {
        audioElement.play()
      }
    },
    submitRecording: function () {},
  },
}
</script>